import styled from 'styled-components';

const GenericSection = styled.div<{ $minWidth?: string; $padding?: string }>`
  min-width: ${(props) => props.$minWidth || '504px'};
  height: 100%;
  padding: ${(props) => props.$padding || '0px'};
  max-width: ${(props) => props.$minWidth || '504px'};
`;

interface SectionProps {
  children: React.ReactNode;
  minWidth?: string;
  padding?: string;
}

const Section = ({ children, minWidth, padding }: SectionProps) => {
  return (
    <GenericSection $minWidth={minWidth} $padding={padding}>
      {children}
    </GenericSection>
  );
};

export default Section;
